import Heading from '@eversports/react-components/primitives/Heading'
import Table, { TableBody, TableHead, TableRow } from '@eversports/react-components/primitives/Table'
import React from 'react'

import { Localized } from '../../localization/react'
import { PurchaseOption as PurchaseOptionType } from '../../typings/Product'
import { PurchaseOption } from '../Product'
import ProductTableCell from '../Product/ProductTableCell'

interface Props {
  products: Array<PurchaseOptionType>
}

const PurchaseOptionsList: React.FC<React.PropsWithChildren<Props>> = ({ products }) => (
  <Table>
    <colgroup>
      <col width="80%" />
      <col width="5%" />
      <col width="15%" />
    </colgroup>
    <TableHead>
      <TableRow>
        <ProductTableCell>
          <Heading is="h4" variant="small">
            <Localized id="product" />
          </Heading>
        </ProductTableCell>
        <ProductTableCell>
          <Heading is="h4" variant="small" textAlign="center">
            <Localized id="product-info" />
          </Heading>
        </ProductTableCell>
        <ProductTableCell>
          <Heading is="h4" variant="small" textAlign="center">
            <Localized id="product-price" />
          </Heading>
        </ProductTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {products.map((product) => (
        <PurchaseOption key={product.id} product={product} />
      ))}
    </TableBody>
  </Table>
)

export default React.memo(PurchaseOptionsList)
